export * from "./tiles.display";
//# sourceMappingURL=index.js.map